
export const getExercisesBaseUrl = (progLang: string) => {
  return "/o/exercises/" + progLang + "/";
}